import { IconDictionary } from "./types";

const validIcons: IconDictionary[] = [
  "search",
  "link",
  "filter",
  "close",
  "drag",
  "toggle",
  "expired",
  "help",
  "dot",
  "email",
  "people",
  "download",
  "upload",
  "warning",
  "image_file",
  "cloud_download",
  "talent_review_insights",
  "add_user",
  "admin",
  "anniversary",
  "arrow_left",
  "arrow_right",
  "birthday",
  "calendar",
  "caret_dn",
  "caret_down",
  "caret_left",
  "caret_right",
  "caret_up",
  "check_in",
  "check_seal",
  "checkmark",
  "clock",
  "comment",
  "earn",
  "eye",
  "feedback",
  "flag",
  "goal_count",
  "goal_percent",
  "goal_task",
  "goals",
  "hamburger",
  "hand_expanded",
  "high_five",
  "home",
  "horizontal_line",
  "hourglass",
  "info",
  "insights",
  "platform_logo",
  "link_arrow",
  "lock",
  "media_error",
  "meatball_menu",
  "moon",
  "nomination",
  "notification",
  "pencil",
  "pin",
  "plus",
  "progress_circle",
  "push_pin",
  "qr_code",
  "recognition",
  "rewards",
  "send_recognition",
  "share_link",
  "skill",
  "smiley",
  "sun",
  "survey",
  "surveys",
  "syncs",
  "talent_review",
  "task_completed",
  "teams",
  "text_bold",
  "text_bulletlist",
  "text_input",
  "text_italic",
  "text_numberlist",
  "text_underline",
  "thumbs_down",
  "thumbs_up",
  "trash",
  "trend_down",
  "trend_up",
  "up_down_caret",
  "vertical_line",
  "warning_no_outline",
];

export function isKazooIcon(icon?: unknown): icon is IconDictionary {
  // @ts-expect-error - assert functions will always present a ts error since we don't know yet if it's a valid type.
  return validIcons.includes(icon);
}

/**
 * Takes a string that might be a KazooIcon and a fallback KazooIcon.
 * If the provided maybe-icon is valid, that icon gets returned. If not, it'll return whatever fallback was provided.
 */
export function checkKazooIconWithFallback<
  T extends IconDictionary | string | null | undefined
>({ icon, fallback }: KazooIconFallbackParams<T>) {
  return isKazooIcon(icon) ? icon : fallback;
}

interface KazooIconFallbackParams<T> {
  icon?: unknown;
  fallback: T;
}
